interface ProjectPlaceholderProps {
  gradient: string;
  letter: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses: Record<string, string> = {
  sm: 'project-placeholder--sm',
  md: 'project-placeholder--md',
  lg: 'project-placeholder--lg',
};

export default function ProjectPlaceholder({
  gradient,
  letter,
  size = 'md',
}: ProjectPlaceholderProps) {
  return (
    <div
      className={`project-placeholder ${sizeClasses[size] || sizeClasses.md}`}
      style={{ background: gradient }}
      aria-hidden="true"
    >
      <span className="project-placeholder__letter">{letter}</span>
    </div>
  );
}
